export default __webpack_public_path__ + "static/media/clock.907240db.svg";